import { setLoading, setGlobalMessage } from '../../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../../api_exception';

const BASE_PATH = "COMPANY_WORK_CONTRACTORS";

export const loadContractors = (rowsPerPage = null, page = null) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        let state = getState().COMPANY_WORK_CONTRACTORS;
        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1,

            filters: [{ name: "state", values: [state.state] },
            { name: "city", values: state.city },
            { name: "firmType", values: state.firmType },
            { name: "workType", values: state.workType }]
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        client.post('/company/contractors', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.contractors) {
                    dispatch(setContractorsData(result.data.contractors,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }


export const loadContractorProfile = (id, viewContact = false) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        let apiPath = `/company/contractor_profile/${id}`;
        if (viewContact) {
            apiPath = `/company/contractor_profile_contact/${id}`;
        }

        client.get(apiPath).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.contractor) {
                    dispatch(setProfileData(result.data.contractor));
                    dispatch(viewVendorProfile(true));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    if(!viewContact){
                        dispatch(setProfileData(null));
                        dispatch(viewVendorProfile(false));
                    }
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setProfileData(null));
            });
    }

export const SET_CONTRACTORS_DATA = `${BASE_PATH}/SET_CONTRACTORS_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const VIEW_VENDOR_PROFILE = `${BASE_PATH}/VIEW_VENDOR_PROFILE`;
export const OPEN_RFQ = `${BASE_PATH}/OPEN_RFQ`;
export const SET_VENDOR_PROFILE = `${BASE_PATH}/SET_VENDOR_PROFILE`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;


export const setContractorsData = (contractors, page, rowsPerPage, totalRows) => ({
    type: SET_CONTRACTORS_DATA,
    contractors,
    page,
    rowsPerPage,
    totalRows
});

export const viewVendorProfile = (open) => ({
    type: VIEW_VENDOR_PROFILE,
    open
});

export const openRfq = (open, selectedVendorName, vendorId) => ({
    type: OPEN_RFQ,
    open,
    selectedVendorName,
    vendorId
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const setProfileData = (data) => ({
    type: SET_VENDOR_PROFILE,
    data
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    contractors: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',

    viewProfile: false,
    openRfq: false,
    selectedVendorName: '',
    vendorId: "",
    profileData: null,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_CONTRACTORS_DATA:
            newState = {
                ...state,
                contractors: [...action.contractors],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VIEW_VENDOR_PROFILE:
            return { ...state, viewProfile: action.open };
        case OPEN_RFQ:
            return {
                ...state, openRfq: action.open,
                selectedVendorName: action.selectedVendorName,
                vendorId: action.vendorId
            };
        case SET_VENDOR_PROFILE:
            return {
                ...state,
                profileData: action.data
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}